import { Component, OnInit, ViewEncapsulation, HostBinding } from '@angular/core';

@Component({
    selector: 'inactive-tenant',
    templateUrl: 'inactive.tenant.component.html',
    styleUrls: ['inactive.tenant.component.less'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class InactiveTenantComponent implements OnInit {
  @HostBinding('class.modern-form') modern = true;

  constructor() {}

  ngOnInit() {}
}
